import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef, useState, useRef, useEffect } from "react";
import { useScrollAreaContext } from "./auth-service-tools543.js";
import { isScrollingWithinScrollbarBounds } from "./auth-service-tools1147.js";
import { getThumbSize } from "./auth-service-tools1145.js";
import { toInt } from "./auth-service-tools1148.js";
import { Scrollbar } from "./auth-service-tools1149.js";
import { useMergedRef } from "./auth-service-tools278.js";
const ScrollAreaScrollbarX = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    sizes,
    onSizesChange,
    style,
    ...others
  } = props;
  const ctx = useScrollAreaContext();
  const [computedStyle, setComputedStyle] = useState();
  const ref = useRef(null);
  const composeRefs = useMergedRef(forwardedRef, ref, ctx.onScrollbarXChange);
  useEffect(() => {
    if (ref.current) {
      setComputedStyle(getComputedStyle(ref.current));
    }
  }, [ref]);
  return /* @__PURE__ */jsxRuntimeExports.jsx(Scrollbar, {
    "data-orientation": "horizontal",
    ...others,
    ref: composeRefs,
    sizes,
    style: { ...style,
      ["--sa-thumb-width"]: `${getThumbSize(sizes)}px`
    },
    onThumbPointerDown: pointerPos => props.onThumbPointerDown(pointerPos.x),
    onDragScroll: pointerPos => props.onDragScroll(pointerPos.x),
    onWheelScroll: (event, maxScrollPos) => {
      if (ctx.viewport) {
        const scrollPos = ctx.viewport.scrollLeft + event.deltaX;
        props.onWheelScroll(scrollPos);

        if (isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) {
          event.preventDefault();
        }
      }
    },
    onResize: () => {
      if (ref.current && ctx.viewport && computedStyle) {
        onSizesChange({
          content: ctx.viewport.scrollWidth,
          viewport: ctx.viewport.offsetWidth,
          scrollbar: {
            size: ref.current.clientWidth,
            paddingStart: toInt(computedStyle.paddingLeft),
            paddingEnd: toInt(computedStyle.paddingRight)
          }
        });
      }
    }
  });
});
ScrollAreaScrollbarX.displayName = "@mantine/core/ScrollAreaScrollbarX";
export { ScrollAreaScrollbarX };